
export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://readdy.ai/api/search-image?query=Lush%20vibrant%20botanical%20garden%20landscape%20with%20morning%20golden%20sunlight%20filtering%20through%20green%20foliage%20and%20flowering%20plants%2C%20professional%20nursery%20greenhouse%20with%20rows%20of%20healthy%20potted%20plants%20and%20flowers%2C%20peaceful%20garden%20atmosphere%20with%20natural%20lighting%2C%20soft%20focus%20background%2C%20professional%20photography%20style%2C%20warm%20natural%20tones%2C%20high%20quality%20botanical%20garden%20scene&width=1920&height=1080&seq=hero-garden-bg&orientation=landscape"
          alt="Beautiful garden landscape"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-8 flex flex-col justify-between py-32">
        <div className="mt-12">
          <h1 className="text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-tight font-serif">
            Cultivating<br />Green Spaces
          </h1>
        </div>

        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <button className="group flex items-center gap-4 bg-white rounded-full pl-8 pr-3 py-3 hover:bg-emerald-50 transition-all duration-300 cursor-pointer whitespace-nowrap">
            <span className="text-lg font-medium text-gray-900">Start Your Gardening Resource</span>
            <div className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-full group-hover:bg-emerald-600 transition-colors">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </button>

          <p className="text-white text-lg lg:text-xl font-medium max-w-md leading-relaxed">
            Expert horticultural services for residential and commercial landscapes and wholesale plants since 2008
          </p>
        </div>
      </div>
    </section>
  );
}
